import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ReportIssue from './ReportIssue';
import { env } from '../config/env.js';

const TopBar = ({
  status,
  isRecording,
  isPaused,
  darkMode,
  onToggleDarkMode
}) => {
  const { user, logout } = useAuth();
  const [showReportIssue, setShowReportIssue] = useState(false);

  return (
    <div className={`top-bar ${isRecording ? 'consultation-active' : ''}`}>
      <div className="status-indicator">
        <div className={`status-dot ${isRecording ? 'recording' : isPaused ? 'paused' : ''}`}></div>
        <span className="status-text">{status}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {/* User Info */}
        {user && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 12px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            fontSize: '14px',
            color: '#3b82f6'
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span style={{ fontWeight: '500' }}>{user.name}</span>
          </div>
        )}

        {/* Report Issue Button — hidden in demo mode (SES unavailable) */}
        {!env.IS_DEMO && (
          <button
            className="btn-secondary"
            onClick={() => setShowReportIssue(true)}
            title="Report a problem"
            style={{
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '14px'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>Report</span>
          </button>
        )}

        {/* Dark Mode Toggle */}
        <button
          className="btn-secondary"
          onClick={onToggleDarkMode}
          title={darkMode ? 'Light mode' : 'Dark mode'}
          style={{ padding: '8px' }}
        >
          {darkMode ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="20" height="20">
              <circle cx="12" cy="12" r="5"/>
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="20" height="20">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          )}
        </button>

        {/* Logout Button */}
        {user && (
          <button
            className="btn-secondary"
            onClick={logout}
            title="Sign out"
            style={{
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '14px'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span>Sign out</span>
          </button>
        )}
      </div>

      {/* Report Issue Modal */}
      {!env.IS_DEMO && showReportIssue && (
        <ReportIssue onClose={() => setShowReportIssue(false)} />
      )}
    </div>
  );
};

export default TopBar;